<template>
  <notification-inbox
    :loading="loading"
    :notifications="notifications"
    :selected-notification="selectedNotification"
    :current-page="pagination.currentPage"
    :total-pages="pagination.size"
    :unread-count="unreadCount"
    :theme="theme"
    :voted="selectedNotification ? !!votedById[selectedNotification.id] : false"
    :voting-busy="votingBusy"
    :general-class-answered="
      selectedNotification
        ? !!generalClassAnsweredById[selectedNotification.id]
        : false
    "
    :general-class-busy="generalClassBusy"
    title="Minhas notificações"
    subtitle="Acompanhe avisos, comunicados e votações da sua turma em um só lugar."
    @select="openNotification"
    @vote="vote"
    @confirm-general-class="confirmGeneralClass"
    @decline-general-class="declineGeneralClass"
    @page-change="handlePageChange"
  />
</template>

<script>
import NotificationInbox from "@/components/notifications/NotificationInbox.vue";
import { classThemes } from "@/shared/classThemes";
import pitchCustomerApi from "@/shared/pitchCustomerApi";

const PAGE_SIZE = 10;

export default {
  name: "NotificationsArea",

  components: {
    NotificationInbox,
  },

  data() {
    return {
      allNotifications: [],
      selectedId: null,
      loading: true,
      votingBusy: false,
      votedById: {},
      generalClassBusy: false,
      generalClassAnsweredById: {},
      pagination: {
        currentPage: 1,
        size: 1,
      },
    };
  },

  computed: {
    notifications() {
      const start = (this.pagination.currentPage - 1) * PAGE_SIZE;
      return this.allNotifications.slice(start, start + PAGE_SIZE);
    },
    selectedNotification() {
      return (
        this.notifications.find((item) => item.id === this.selectedId) || null
      );
    },
    unreadCount() {
      return this.allNotifications.filter((item) => !item.read).length;
    },
    theme() {
      return classThemes.customer;
    },
  },

  mounted() {
    this.getNotifications();
  },

  methods: {
    async getNotifications(preferredId = this.selectedId) {
      this.loading = true;

      try {
        const res = await pitchCustomerApi.getNotifications();
        this.allNotifications = res.data?.data || [];
        this.pagination.size =
          Math.max(1, Math.ceil(this.allNotifications.length / PAGE_SIZE)) || 1;
        this.syncSelection(preferredId);
        this.updateStore();
      } catch {
        this.$root.$emit("display-alert", {
          text: "Ocorreu um problema ao carregar as suas notificações.",
          type: 1,
        });
      } finally {
        this.loading = false;
      }
    },
    syncSelection(preferredId = null) {
      if (!this.notifications.length) {
        this.selectedId = null;
        return;
      }

      const match = this.notifications.find((item) => item.id === preferredId);
      this.selectedId = (match || this.notifications[0]).id;
    },
    async openNotification(item) {
      this.selectedId = item.id;

      if (!item.read) {
        try {
          await pitchCustomerApi.readNotification(item.id);
          item.read = true;
          this.updateStore();
        } catch {
          this.$root.$emit("display-alert", {
            text: "Ocorreu um problema ao ler a notificação.",
            type: 1,
          });
        }
      }
    },
    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.syncSelection();
    },
    updateStore() {
      this.$store.dispatch("setNotificationsCount", this.unreadCount);
    },
    async vote({ voteId, option }) {
      const currentId = this.selectedId;
      this.votingBusy = true;

      try {
        const res = await pitchCustomerApi.vote(voteId, option);
        this.$set(this.votedById, currentId, true);
        this.$root.$emit("display-alert", {
          text: res.data.message,
          type: 0,
        });
        await this.getNotifications(currentId);
      } catch (err) {
        this.$root.$emit("display-alert", {
          text:
            err?.response?.data?.message ||
            "Nao foi possivel registrar o seu voto.",
          type: 1,
        });
      } finally {
        this.votingBusy = false;
      }
    },
    async confirmGeneralClass({ sessionId }) {
      const currentId = this.selectedId;
      this.generalClassBusy = true;

      try {
        await pitchCustomerApi.participateInGeneralClass(sessionId);
        this.$set(this.generalClassAnsweredById, currentId, true);
        this.$root.$emit("display-alert", {
          text: "Participação confirmada.",
          type: 0,
        });
        await this.getNotifications(currentId);
      } catch (err) {
        this.$root.$emit("display-alert", {
          text:
            err?.response?.data?.message ||
            "Não foi possível confirmar a participação.",
          type: 1,
        });
      } finally {
        this.generalClassBusy = false;
      }
    },
    async declineGeneralClass({ sessionId }) {
      const currentId = this.selectedId;
      this.generalClassBusy = true;

      try {
        await pitchCustomerApi.declineGeneralClass(sessionId);
        this.$set(this.generalClassAnsweredById, currentId, true);
        this.$root.$emit("display-alert", {
          text: "Resposta registrada.",
          type: 0,
        });
        await this.getNotifications(currentId);
      } catch (err) {
        this.$root.$emit("display-alert", {
          text:
            err?.response?.data?.message ||
            "Não foi possível registrar a resposta.",
          type: 1,
        });
      } finally {
        this.generalClassBusy = false;
      }
    },
  },
};
</script>
